export default function InsiderGuide() {
  return (
    <section className="bg-[#F5F1EB] py-28 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="w-full h-[540px] overflow-hidden rounded-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/d031c6c9472b2241367db0283bd7ea7e.jpg"
                alt="Highlands NC mountain town nestled in the Appalachians"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -right-6 bg-[#2D4A3E] text-white p-8 rounded-2xl max-w-[220px]">
              <p className="font-cormorant text-4xl font-light leading-none mb-1">4,118<span className="text-2xl">'</span></p>
              <p className="text-white/70 text-xs font-jost tracking-widest uppercase mt-1">Above Sea Level</p>
              <div className="w-8 h-px bg-[#C9A96E] my-3" />
              <p className="text-white/60 text-xs font-jost leading-relaxed">America's highest incorporated town east of the Rockies</p>
            </div>
          </div>

          <div className="lg:pl-8">
            <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-6">/ Our Story</p>
            <h2 className="font-cormorant text-5xl md:text-6xl text-[#1A1A18] font-light leading-tight mb-8">
              The Insider's Guide<br />
              <em className="italic">to Highlands, NC</em>
            </h2>
            <p className="text-[#5C5850] font-jost text-base leading-relaxed mb-6">
              Nestled at 4,118 feet in the Nantahala National Forest, Highlands, North Carolina is one of the most extraordinary small towns in America. With over 125 inches of annual rainfall, the surrounding landscape is lush, dramatic, and perpetually alive — cascading waterfalls, ancient forests, and mountain views that genuinely take your breath away.
            </p>
            <p className="text-[#5C5850] font-jost text-base leading-relaxed mb-6">
              This guide exists because we believe you deserve more than a generic booking platform. We know these mountains intimately — which cabins offer the best sunrise views, which properties are truly pet-welcoming, and which waterfalls are best experienced in solitude at dawn.
            </p>
            <p className="text-[#5C5850] font-jost text-base leading-relaxed mb-10">
              Every property featured here has been personally evaluated for quality, accuracy, and the intangible magic that makes a stay truly memorable.
            </p>

            <div className="grid grid-cols-3 gap-6">
              {[
                { value: '50+', label: 'Curated Properties' },
                { value: '15+', label: 'Years of Local Insight' },
                { value: '10K+', label: 'Happy Travelers' },
              ].map((stat) => (
                <div key={stat.label} className="text-center border-r border-[#E5E0D8] last:border-0 pr-6 last:pr-0">
                  <p className="font-cormorant text-4xl text-[#2D4A3E] font-light mb-1">{stat.value}</p>
                  <p className="text-[#9C9890] text-xs font-jost tracking-widest uppercase leading-tight">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}